import CreateResource from "../../features/CorporateResource/CreateResource";
import "./CreateResources.scss"

const CreateResourcesPage = () => {
  return (
    <div>
      <CreateResource />
    </div>
  );
};

export default CreateResourcesPage;
